import { render, staticRenderFns } from "./Workgroup.vue?vue&type=template&id=44258b7c&scoped=true"
import script from "./Workgroup.vue?vue&type=script&lang=js"
export * from "./Workgroup.vue?vue&type=script&lang=js"
import style0 from "./Workgroup.vue?vue&type=style&index=0&id=44258b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44258b7c",
  null
  
)

export default component.exports